import React from 'react';
import cx from 'classnames';
import '../../affilates/AffilatePanel/index.js';
import '../../affilates/AffilateProgram/index.js';
import '../../affilates/AffilatesTabs/index.js';
import '../../affilates/AffilatesNavBanner/index.js';
import '../../../icons/ActivityIcon.js';
import '../../../icons/AgeIcon.js';
import '../../../icons/ArrowDownV2.js';
import '../../../icons/ArrowDownV3.js';
import '../../../icons/ArrowDown.js';
import '../../../icons/ArrowLeftBig.js';
import '../../../icons/ArrowLeft.js';
import '../../../icons/ArrowLeft2.js';
import '../../../icons/ArrowsDown.js';
import '../../../icons/ArrowsUp.js';
import '../../../icons/ArrowUpRightIcon.js';
import '../../../icons/Baccarat.js';
import '../../../icons/BlackJack.js';
import '../../../icons/BookIcon.js';
import '../../../icons/Calendar.js';
import '../../../icons/Carts.js';
import '../../../icons/ChartIcon.js';
import '../../../icons/ChainIcon.js';
import '../../../icons/CheckIcon2.js';
import '../../../icons/CheckIcon.js';
import '../../../icons/Checks.js';
import '../../../icons/ChevronDown.js';
import '../../../icons/Clock.js';
import '../../../icons/Close.js';
import '../../../icons/CoinsIcon.js';
import '../../../icons/Coins.js';
import '../../../icons/CopyIconDouble.js';
import '../../../icons/CopyIconFill.js';
import '../../../icons/Crown.js';
import '../../../icons/CryptoCurrency.js';
import '../../../icons/DiscordIcon.js';
import '../../../icons/DiscordIconV2.js';
import '../../../icons/Dota2.js';
import '../../../icons/Edit.js';
import '../../../icons/ExtendIcon.js';
import '../../../icons/EyeOff.js';
import '../../../icons/Eye.js';
import '../../../icons/FacebookIconV2.js';
import '../../../icons/FacebookIcon.js';
import '../../../icons/FiatCurrency.js';
import '../../../icons/FilterIcon.js';
import '../../../icons/GameIcon.js';
import '../../../icons/GameShows.js';
import '../../../icons/Game.js';
import '../../../icons/HeadPhones.js';
import '../../../icons/HomeIcon.js';
import '../../../icons/Horse.js';
import '../../../icons/InfoFill.js';
import '../../../icons/InfoIcon2.js';
import '../../../icons/InfoIcon.js';
import '../../../icons/InfoOutline.js';
import '../../../icons/LevelUp.js';
import '../../../icons/LinkIcon.js';
import '../../../icons/Link.js';
import '../../../icons/LiveCasino.js';
import '../../../icons/LiveIcons2.js';
import '../../../icons/LobbyIconV2.js';
import '../../../icons/LobbyIcon.js';
import '../../../icons/LogoSmallIcon.js';
import '../../../icons/Lock.js';
import '../../../icons/LOL.js';
import '../../../icons/MaxIcon.js';
import '../../../icons/MedalIcon.js';
import '../../../icons/MedalStarIcon.js';
import '../../../icons/MoneyBagIcon.js';
import '../../../icons/MoneyIcon.js';
import '../../../icons/MoneyRecive.js';
import '../../../icons/NewTwitterIcon.js';
import '../../../icons/OriginalsIcon.js';
import '../../../icons/Original.js';
import '../../../icons/PersonIcon.js';
import '../../../icons/PhoneChatIcon.js';
import '../../../icons/PhotoUp.js';
import '../../../icons/PlayIcon.js';
import '../../../icons/PlusIcon.js';
import '../../../icons/RainIcon.js';
import '../../../icons/RankIcon.js';
import '../../../icons/RankinIcon.js';
import '../../../icons/ReferalIcon.js';
import '../../../icons/RefreshIcon.js';
import '../../../icons/Reload.js';
import '../../../icons/Roulette.js';
import '../../../icons/Search2Icon.js';
import '../../../icons/Search.js';
import '../../../icons/SendIcon.js';
import '../../../icons/Settings2.js';
import '../../../icons/SettingsV3.js';
import '../../../icons/Settings.js';
import '../../../icons/SlotsIcon2.js';
import '../../../icons/SlotsIcon.js';
import '../../../icons/SmileIcon.js';
import '../../../icons/SocialsIcon.js';
import '../../../icons/SortIcon.js';
import '../../../icons/SponsorshipIcon.js';
import '../../../icons/StarFill.js';
import '../../../icons/StarCraft.js';
import '../../../icons/StopIcon.js';
import '../../../icons/TableGamesIcon.js';
import '../../../icons/TelegramIcon.js';
import '../../../icons/TelegramIconV2.js';
import '../../../icons/TopPicksIcon.js';
import '../../../icons/Upload.js';
import '../../../icons/UserMoney.js';
import '../../../icons/UsersIconV2.js';
import '../../../icons/UsersIcon.js';
import '../../../icons/VerifiedIcon.js';
import '../../../icons/WalletAddIcon.js';
import '../../../icons/Wallet.js';
import '../../../icons/WarningIcon.js';
import '../../../icons/DeviceDesktop.js';
import '../../../icons/DeviceTablet.js';
import '../../../icons/DevicePhone.js';
import '../../../icons/ClockOrange.js';
import '../../../icons/CalendarOrange.js';
import '../../../icons/OpenLinkIcon.js';
import '../../../icons/FavoriteFill.js';
import '../../../icons/EditorChoiceV2.js';
import '../../../icons/ListBullet.js';
import '../../../icons/BankIcon.js';
import '../../../icons/ClockOrangeV2.js';
import '../../../icons/CalendarOrangeV2.js';
import '../../../icons/ReferralIconV2.js';
import '../../../icons/MoneyIconV2.js';
import '../../../icons/UsersIconV3.js';
import '../../../icons/InfoFillV2.js';
import '../../../icons/LockOrange.js';
import '../../../icons/LockV2.js';
import '../../../icons/AlertOrange.js';
import '../../../icons/LiveSupportV2.js';
import '../../../icons/Chat.js';
import '../../../icons/CrossCircle.js';
import '../../../icons/LockV3.js';
import '../../../icons/CoinCrypto.js';
import '../../../ui/accordions/Accordion/index.js';
import '../../../ui/accordions/AccordionSelect/index.js';
import '../../../ui/badges/Badge/index.js';
import '../../../ui/badges/BadgeIcon/index.js';
import '../../../ui/badges/Checked/index.js';
import '../../../ui/badges/Panel/index.js';
import '../../../ui/badges/Status/index.js';
import '../../../ui/badges/Tag/index.js';
import '../../../ui/buttons/BabyButton/Base.js';
import '../../../ui/buttons/BabyButton/variants/Chat/index.js';
import '../../../ui/buttons/BabyButton/variants/Menu/index.js';
import '../../../ui/buttons/BabyButton/variants/User/index.js';
import '../../../ui/buttons/BabyButton/variants/Vip/index.js';
import '../../../ui/buttons/BabyButton/variants/Wallet/index.js';
import '../../../ui/buttons/Button/index.js';
import '../../../ui/buttons/CloseButton/index.js';
import '../../../ui/buttons/DirectionButton/index.js';
import '../../../ui/buttons/GradientButton/index.js';
import '../../../ui/buttons/GradientButtonV2/index.js';
import '../../../ui/buttons/TabButton/index.js';
import '../../../ui/buttons/TabButtonV2/index.js';
import '../../../ui/buttons/TimerButton/index.js';
import '../../../ui/buttons/TimerButtonV2/index.js';
import '../../../ui/buttons/TimerButtonV3/index.js';
import '../../../ui/loaders/Loader/index.js';
import '../../../ui/loaders/ScreenLoader/index.js';
import '../../../ui/modals/Modal/MobileWrapperV2/index.js';
import '../../../ui/modals/Modal/Modal.js';
import '../../../ui/modals/Modal/ModalContentWrapper/index.js';
import '../../../ui/popups/Popper/index.js';
import '../../../ui/popups/Popup/BasePopup/index.js';
import '../../../ui/popups/Popup/Thumb/index.js';
import '../../../ui/popups/Popup/ThumbV2/index.js';
import '../../../ui/popups/Popup/InfoTooltip/index.js';
import '../../../ui/sliders/EmblaCarousel/index.js';
import '../../../ui/tables/Table/index.js';
import '../../../ui/tables/Table/TableTd/index.js';
import '../../../ui/tabs/Tabs/index.js';
import '../../../ui/tabs/TabsV2/index.js';
import '../../../ui/texts/CryptoValue/index.js';
import '../../../ui/texts/AmountValue/index.js';
import '../../../ui/texts/TitleWithCurrency/index.js';
import '../../../ui/texts/Text/index.js';
import '../../../ui/texts/TextNavigation/index.js';
import '../../../ui/texts/MinValue/index.js';
import '../../../ui/socials/SocialsList/index.js';
import '../../transactions/TransactionID/index.js';
import '../../transactions/TransactionLayout/index.js';
import '../../transactions/TransactionPanel/index.js';
import '../../transactions/TransactionTabs/index.js';
import '../../transactions/TransactionToolbar/index.js';
import '../../affilates/Panels/DashboardPanel/index.js';
import '../../affilates/Panels/EarningsPanel/index.js';
import '../../affilates/ProgramDescription/index.js';
import '../../auth/common/Steps/index.js';
import '../../auth/common/StepsWrapper/index.js';
import '../../auth/common/Wrapper/index.js';
import '../../auth/Form/AddReferral/index.js';
import '../../auth/Form/Button/index.js';
import '../../auth/Form/Divider/index.js';
import '../../auth/Form/ForgotPassword/index.js';
import '../../auth/Form/FormGroup/index.js';
import '../../auth/Form/FormTitle/index.js';
import '../../auth/Form/NavLink/index.js';
import '../../auth/Form/Row/index.js';
import '../../auth/Form/Wrapper/index.js';
import '../../auth/Form/FormSubTitle/index.js';
import '../../auth/Form/AnimationWrapper/index.js';
import '../../auth/Form/ForgotPasswordWrapper/index.js';
import '../../auth/Verification/index.js';
import '../../banners/TimerBanner/index.js';
import '../../banners/RaceToMars/index.js';
import '../../banners/BannerGrid/index.js';
import '../../banners/BannerGridV2/index.js';
import '../../banners/BannerGridV3/index.js';
import '../../charts/LiveStatsChart/index.js';
import '../../copy/CopyInput/index.js';
import '../../copy/CopyValue/index.js';
import '../../crypto/CryptoStatistic/index.js';
import '../../crypto/CryptoStatisticList/index.js';
import '../../footer/Footer/index.js';
import '../../footer/FooterContacts/index.js';
import '../../footer/FooterList/index.js';
import '../../forms/2FA/Button/index.js';
import '../../forms/2FA/LostPin/index.js';
import '../../forms/2FA/Row/index.js';
import '../../forms/2FA/Text/index.js';
import '../../forms/2FA/Wrapper/index.js';
import '../../forms/2FA/EmailHint/index.js';
import '../../forms/PinForm/ErrorMessage/index.js';
import '../../forms/PinForm/Row/index.js';
import '../../forms/PinForm/Wrapper/index.js';
import '../../forms/PinForm/Title/index.js';
import '../../forms/PinForm/Form/index.js';
import '../../forms/AdvVerify/Form/index.js';
import '../../forms/AdvVerify/Group/index.js';
import '../../forms/AdvVerify/Info/index.js';
import '../../forms/AdvVerify/Row/index.js';
import '../../forms/AdvVerify/Step/index.js';
import '../../forms/AdvVerify/Wrapper/index.js';
import '../../forms/BasicVerify/Form/index.js';
import '../../forms/BasicVerify/Row/index.js';
import '../../forms/BasicVerify/Wrapper/index.js';
import '../../forms/ChangePass/Form/index.js';
import '../../forms/ChangePass/Row/index.js';
import '../../forms/ChangePass/Wrapper/index.js';
import '../../forms/ContactVerify/Form/index.js';
import '../../forms/ContactVerify/Row/index.js';
import '../../forms/ContactVerify/Wrapper/index.js';
import '../../forms/TwoFactorAuth/Form/index.js';
import '../../forms/TwoFactorAuth/Row/index.js';
import '../../forms/TwoFactorAuth/Wrapper/index.js';
import '../../forms/TwoFactorAuth/WideButton/index.js';
import '../../forms/SecurityVerify/Content/index.js';
import '../../forms/SecurityVerify/Form/index.js';
import '../../forms/SecurityVerify/RequestCode/index.js';
import '../../forms/SecurityVerify/Title/index.js';
import '../../forms/SecurityVerify/Row/index.js';
import '../../forms/SecurityVerify/Value/index.js';
import '../../forms/SecurityVerify/Wrapper/index.js';
import '../../forms/SecurityVerify/EditValue/index.js';
import '../../forms/SelfExclusion/Form/index.js';
import '../../forms/SelfExclusion/Group/index.js';
import '../../forms/SelfExclusion/Row/index.js';
import '../../forms/SelfExclusion/Wrapper/index.js';
import '../../forms/Wallet/WalletForm/index.js';
import '../../forms/Wallet/Warning/index.js';
import '../../forms/VerifyForm/Form/index.js';
import '../../forms/VerifyForm/Row/index.js';
import '../../forms/VerifyForm/Wrapper/index.js';
import '../../forms/UserInfoEditForm/Row/index.js';
import '../../forms/UserInfoEditForm/Wrapper/index.js';
import '../../forms/UserInfoEditForm/Form/index.js';
import '../../forms/UserInfoEditForm/AvatarBlock/index.js';
import '../../forms/UserInfoEditForm/Title/index.js';
import '../../forms/UserInfoEditForm/Text/index.js';
import '../../forms/UserInfoEditForm/WrapperButtons/index.js';
import '../../forms/UserInfoEditForm/WarningIcon/index.js';
import '../../forms/LogoutForm/Row/index.js';
import '../../forms/LogoutForm/Wrapper/index.js';
import '../../forms/LogoutForm/WrapperButtons/index.js';
import '../../forms/LogoutForm/Title/index.js';
import '../../forms/LogoutForm/WrapperImage/index.js';
import '../../forms/LogoutForm/Image/index.js';
import '../../game/GameAccordion/index.js';
import '../../game/GameBanner/index.js';
import '../../../common/DateFormat/index.js';
import '@anton.bobrov/react-hooks';
import '@anton.bobrov/react-components';
import '../../../common/GradientWrapper/index.js';
import '../../../common/Icon/index.js';
import '../../../common/LazyImage/index.js';
import '../../../common/NumberFormat/index.js';
import '../../../common/WithCustomScrollbar/index.js';
import '../../game/GameStat/index.js';
import '../../game/GameStatTitle/index.js';
import '../../lists/GameList/GameListHeader/index.js';
import '../../lists/GameList/index.js';
import '../../lists/GamesListTopBar/index.js';
import '../../lists/LiveLoad/index.js';
import '../../lists/LiveWins/index.js';
import '../../lists/NavigationBar/index.js';
import '../../lists/PageNavigationBar/index.js';
import '../../lists/NavigationBarV2/index.js';
import '../../lists/PageNavigationBarV2/index.js';
import '../../lists/Pagination/index.js';
import '../../lists/PaginationLocal/index.js';
import '../../lists/ProvidersList/ProvidersListHeader/index.js';
import '../../lists/ProvidersList/index.js';
import '../../lists/SocialLinks/index.js';
import '../../modals/AccessModal/index.js';
import '../../modals/AuthModal/index.js';
import '../../modals/DefaultModal/index.js';
import '../../modals/FilterModal/index.js';
import '../../modals/LiveStats/Modal/index.js';
import '../../modals/LiveStats/Row/index.js';
import '../../modals/PlayModal/index.js';
import '../../modals/ProfileModal/index.js';
import '../../modals/RedeemCodeModal/index.js';
import { useWindowSize } from '../../../../utils/hooks/useWindowSize.js';
import '../../modals/UserInfoModal/UserInfoGameList/index.js';
import '../../modals/UserInfoModal/UserInfoRewardsList/index.js';
import '../../modals/UserInfoModal/Modal/index.js';
import '../../modals/UserInfoModal/Row/index.js';
import '../../modals/UserInfoModal/RowItem/index.js';
import '../../modals/UserInfoModal/UserInfoUser/index.js';
import '../../modals/UserInfoModal/Panel/index.js';
import 'react-router-dom';
import '../../../form/CheckBox/index.js';
import '../../../form/CodeInput/index.js';
import '../../../form/CryptoSelect/index.js';
import '../../../form/FileUploader/index.js';
import '../../../form/FormInput/index.js';
import '../../../form/FormSelect/index.js';
import '../../../form/PhoneInput/index.js';
import '../../../form/RadioButton/index.js';
import '../../../form/Select/index.js';
import '../../../form/SelectV2/index.js';
import '../../../form/SelectV3/index.js';
import '../../../form/SelectV4/index.js';
import '../../../form/Search/Input/index.js';
import '../../../form/Search/NoResults/index.js';
import '../../../form/Switch/index.js';
import '../../../form/DatePickerInput/index.js';
import '../../../cards/AuthPromo/index.js';
import '../../../cards/Card/index.js';
import '../../../cards/CategoryCard/index.js';
import '../../../cards/CryptoFeature/index.js';
import '../../../cards/GamePreview/index.js';
import '../../../cards/Promo/PromoCardSimple/index.js';
import '../../../cards/Promo/PromotionCard/index.js';
import '../../../cards/Provider/index.js';
import '../../../cards/SportsBook/index.js';
import '../../../cards/SecurityCard/index.js';
import '../../../cards/WinCard/index.js';
import '../../modals/AdvancedVerificationModal/index.js';
import '../../modals/BasicVerificationModal/index.js';
import '../../modals/ChangePasswordModal/index.js';
import '../../modals/ContactVerificationModal/index.js';
import '../../modals/TwoFactorAuthModal/index.js';
import '../../modals/VerificationPinModal/index.js';
import '../../modals/SelfExclusionModal/index.js';
import '../../modals/WalletModal/index.js';
import '../../modals/RewardsClaimModal/index.js';
import '../../modals/RewardsSliderInfoModal/index.js';
import '../../modals/VipRewardsModal/index.js';
import '../../modals/VerificationModal/index.js';
import '../../modals/ConfirmChangeSliderModal/index.js';
import '../../modals/ReconectSocketModal/index.js';
import '../../modals/LogoutModal/index.js';
import '../../modals/UnavailableModal/index.js';
import '../../modals/FA2Modal/index.js';
import '../../news/ArticleMetadata/index.js';
import '../../news/Article/index.js';
import '../../notifications/MarkAsReadButton/index.js';
import '../../notifications/Notification/index.js';
import '../../notifications/NotificationsList/index.js';
import '../../notifications/NotificationsModal/index.js';
import '../../notifications/NotificationsTabs/index.js';
import '../../notifications/NotificationsPopup/index.js';
import '../../qrcodes/QrCode/index.js';
import '../Progress/index.js';
import '../RewardIcon/index.js';
import '../RewardIconWrapper/index.js';
import { RewardsProgressBar } from '../RewardsProgressBar/index.js';
import '../RewardStatus/index.js';
import '../VipIcon/index.js';
import '../InstantRakeback/index.js';
import '../Range/index.js';
import '../VipReload/index.js';
import '../RewardWallet/index.js';
import '../RewardHorizontal/index.js';
import '../RewardHorizontalV2/index.js';
import '../Reward/index.js';
import '../AvailableProgress/index.js';
import '../Benefits/index.js';
import '../CountDownBanner/index.js';
import '../ProgressWidget/index.js';
import '../RewardsSliderPreview/index.js';
import '../RewardsSlider/index.js';
import '../VipLevelLine/index.js';
import '../VipLevelAccordion/index.js';
import '../VipRewards/index.js';
import '../RewardsList/index.js';
import '../RewardTypeIcon/index.js';
import '../RewardsDropdown/RDContent/index.js';
import '../RewardsDropdown/RDFooter/index.js';
import '../RewardsDropdown/RDHeader/index.js';
import '../RewardsDropdown/RDList/index.js';
import '../RewardsDropdown/RDRow/index.js';
import '../RewardsDropdown/RDStatistic/index.js';
import '../RewardsDropdown/RDWrapper/index.js';
import '../../sections/CategoryTitle/index.js';
import '../../sections/FadeUpWrapper/index.js';
import '../../sections/LoggedWelcomeText/index.js';
import '../../sections/PromoSection/index.js';
import '../../sections/SectionTitle/index.js';
import '../../sections/SectionTitleV2/index.js';
import '../../sections/SignInText/index.js';
import '../../sections/TextNavigationWrapper/index.js';
import '../../sections/UnavailableSection/index.js';
import '../../sections/OtherServicesAuth/OtherServicesAuthModalText/index.js';
import '../../sections/OtherServicesAuth/OtherServicesAuthModalWrapper/index.js';
import '../../settings/SettingsTabs/index.js';
import '../../settings/Profile/EmailVerification/index.js';
import '../../settings/Profile/User/index.js';
import '../../settings/Security/LinkedAccounts/AccountItem/index.js';
import '../../settings/Security/LinkedAccounts/index.js';
import '../../settings/Security/Sessions/index.js';
import '../../settings/Panels/SecurityPanel/index.js';
import '../../settings/Panels/ProfilePanel/index.js';
import '../../settings/Panels/PreferencesPanel/index.js';
import '../../settings/Panels/GamingPanel/index.js';
import '../../settings/Panels/IgnoredUsersPanel/index.js';
import '../../sliders/AuthSlider/index.js';
import '../../sliders/PromoSlider/index.js';
import '../../toast/ToastContent/index.js';
import '../../toast/ToastIcon/index.js';
import '../../toast/ToastPortal/index.js';
import 'react-toastify';
import '../../user/UserInfo/index.js';
import '../../user/AvatarName/index.js';
import '../../user/UserName/index.js';
import '../../user/UserCryptoLine/index.js';
import '../../user/UserRainLine/index.js';
import '../../user/UserInfoStat/index.js';
import '../../user/UserInfoWrapper/index.js';
import '../../wallet/CategoryList/index.js';
import '../../wallet/WalletTabs/index.js';
import '../../wallet/MainWrapper/index.js';
import '../../wallet/VerifyAccordion/index.js';
import '../../chat/wrappers/MainWrapper/index.js';
import '../../chat/wrappers/HeaderWrapper/index.js';
import '../../chat/wrappers/BodyWrapper/index.js';
import '../../chat/wrappers/FooterWrapper/index.js';
import '../../chat/components/MessagesInfo/index.js';
import '../../chat/components/Bet/index.js';
import '../../chat/components/Rain/index.js';
import '../../chat/components/Tip/index.js';
import '../../chat/components/UserName/index.js';
import '../../chat/components/UserTag/index.js';
import '../../chat/components/Comment/index.js';
import '../../chat/components/ActionList/index.js';
import '../../chat/components/ActionListPopper/index.js';
import '../../chat/components/Composer/index.js';
import '../../chat/components/ChatInput/index.js';
import '../../chat/components/PinnedСomment/index.js';
import '../../chat/components/ComposerState/index.js';
import '../../chat/components/ChatInfo/index.js';
import '../../preview/MaintainTimer/index.js';
import '../../tooltip/Tooltip/index.js';
import mask1 from './image/mask-1.png.js';
import mask2 from './image/mask-2.png.js';
import mask1v2 from './image/mask-1-v2.png.js';
import mask2v2 from './image/mask-2-v2.png.js';
import styles from './index.module.scss.js';

const mask = {
  v1: {
    1: mask1,
    2: mask2
  },
  v2: {
    1: mask1v2,
    2: mask2v2
  }
};
const VipProgress = ({
  revard,
  nextRevard,
  forceMobileStyles,
  className,
  style,
  texts = {
    title: "Your VIP progress",
    description: "Housebets VIP Program is designed to suit all different types of  players with an emphasis on ensuring you receive the most in cumulative bonuses for every dollar you wager.",
    currentReward: "Current revard",
    nextReward: "Next revard",
    upToNext: "Up to the next level"
  },
  type = "v2",
  ...props
}) => {
  const { isMobile } = useWindowSize();
  return /* @__PURE__ */ React.createElement(
    "div",
    {
      className: cx("aos-init", styles.box, className, {
        [styles["mobile-styles"]]: forceMobileStyles,
        [styles[type]]: !!type
      }),
      style,
      ...props
    },
    /* @__PURE__ */ React.createElement("div", { className: cx(styles["box-inner"]) }, /* @__PURE__ */ React.createElement("div", { className: cx(styles.row) }, /* @__PURE__ */ React.createElement("div", { className: cx(styles.title) }, texts.title), /* @__PURE__ */ React.createElement("div", { className: cx(styles.description) }, texts.description)), /* @__PURE__ */ React.createElement("div", { className: cx(styles["progress-bars"]) }, /* @__PURE__ */ React.createElement("div", { className: cx(styles.col) }, /* @__PURE__ */ React.createElement(
      RewardsProgressBar,
      {
        text: {
          currentTitle: texts.currentReward,
          nextTitle: texts.upToNext
        },
        reward: revard,
        forceMobileStyles,
        type: type === "v2" ? "v3" : "v1"
      }
    )), !isMobile && !forceMobileStyles && /* @__PURE__ */ React.createElement("div", { className: cx(styles.col) }, /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(
      RewardsProgressBar,
      {
        text: {
          currentTitle: texts.nextReward,
          nextTitle: ""
        },
        reward: nextRevard,
        type: type === "v2" ? "v3" : "v1"
      }
    ))))),
    type === "v2" && /* @__PURE__ */ React.createElement("div", { className: styles.mask3 }),
    mask[type][1] && /* @__PURE__ */ React.createElement("div", { className: cx(styles["background-mask1"]) }, /* @__PURE__ */ React.createElement("img", { src: mask[type][1], alt: "vip-mask-1" })),
    mask[type][2] && /* @__PURE__ */ React.createElement("div", { className: cx(styles["background-mask2"]) }, /* @__PURE__ */ React.createElement("img", { src: mask[type][2], alt: "vip-mask-2" }))
  );
};
VipProgress.displayName = "VipProgress";

export { VipProgress };
//# sourceMappingURL=index.js.map
